<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">

      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-purse</v-icon>{{$t('qualitycheck.product.data')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProductDataForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProductDataForm from '../../components/productdata/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProductData';

const { mapFields } = createHelpers({
  getterType: 'productdata/getField',
  mutationType: 'productdata/updateField'
});

export default {
  name: 'ProductDataCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProductDataForm
  },
  data() {
    return {
      item: {
        'product' : this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('productdata', ['create', 'reset'])
  }
};
</script>
